var $ = require('jquery')
// ImagesLoaded
var imagesLoaded = require('imagesloaded')
imagesLoaded.makeJQueryPlugin( $ )
import './velocity.min.js'

// import animator from './animator'
import toggler from './toggler'
import utils from './utils'

$(function () {
  $("body").addClass("mti-active");
  utils.isMobile() && window.addEventListener("touchstart", function a() {
    $("body").addClass("touched"), window.removeEventListener("touchstart", a)
  }, !1)
  // animator.init();
  toggler.init();
  // highlow_locale.init();

  // TOP NAV
  function a(a) {
    var e = $(a.target);
    $(window).width() > d && ($(e.closest(".main-menu-toggle-label")).length > 0 || $(e.closest(".dropdown-mega-menu")).length > 0 || (b.removeClass("open"), c.removeClass("open")))
  }
  if ($("#main-menu").length > 0) {
    var b = $("#main-menu .menu-bar-menu > li"),
      c = $(".dropdown-mega-menu");
    if ($(".dropdown-mega-menu.disabled").length > 0) return;
    var d = 768;
    b.each(function () {
      var a = $(this),
        e = a.find(".main-menu-toggle-label"),
        f = $(a.data("toggleTarget") + ".dropdown-mega-menu");
      var g, h = !1,
        i = !1;
      e.mouseenter(function () {
        a.addClass("open"), h = !0
      }), a.click(function () {
        $(window).width() <= d && (a.hasClass("open") ? a.removeClass("open") : (b.removeClass("open"), a.addClass("open")))
      }), e.mouseleave(function () {
        i || (j = setTimeout(function () {
          clearTimeout(g), a.removeClass("open"), f.removeClass("open"), i = !1, h = !1
        }, 100))
      });
      var j;
      f.mouseenter(function () {
        clearTimeout(j)
      }), a.mouseenter(function () {
        clearTimeout(j), g = setTimeout(function () {
          h && (f.addClass("open"), i = !0)
        }, 500)
      }), a.mouseleave(function (b) {
        j = setTimeout(function () {
          a.removeClass("open"), f.removeClass("open"), i = !1, h = !1
        }, 250)
      }), f.mouseleave(function (b) {
        j = setTimeout(function () {
          a.removeClass("open"), f.removeClass("open"), i = !1, h = !1
        }, 250)
      }), a.on("touchstart", function () {
        $(window).width() > d && (a.hasClass("open") ? (a.removeClass("open"), c.removeClass("open")) : (b.removeClass("open"), a.addClass("open"), c.removeClass("open"), f.addClass("open")))
      })
    }) 
    $(document).on("touchstart", a)
    $(document).on("click", a)
  }
});